import React from 'react'

export default function Logo(props) {
  return <img src={'/hyvilo.png'} height={57} {...props} />
}
